import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import RestoreIcon from '@mui/icons-material/Restore';

import Button from '../../formElements/Button';
import InitialAppointmentPONumberNotice from '../../ui/notices/initialAppointmentPONumber/InitialAppointmentPONumberNotice';
import { cancelledStatuses } from '../utils/calendarUtils';

import app from '../../../app.module.css';
import styles from '../styles/startAppointmentButton.module.css';

const AttendanceRow = ({
    isDisabled = false,
    isUpdateDisabled = false,
    hasParticipantAccess,
    hasGroup1Role,
    hasEditOnClosedRole,
    canConductAppointment,
    isAuditable,
    onSearchAuditItems,
    attendanceStatus,
    appointmentType,
    isPONumberRequired,
    participant,
    onNav,
    onStartAppointment,
    onUpdateAppointment
}) => {
    // LOCAL STATE
    const [showWarning, setShowWarning] = useState(false);

    // USEEFFECTS
    useEffect(() => {
        setShowWarning(
            appointmentType === 'initial' &&
                !participant?.poNumber &&
                isPONumberRequired &&
                (!isDisabled || !isUpdateDisabled) &&
                !cancelledStatuses.includes(attendanceStatus)
        );
    }, [isPONumberRequired, participant, appointmentType, isDisabled, isUpdateDisabled]);

    // RENDER
    return (
        <>
            <div
                className={`${styles.appointmentButtonRow} ${app.fadein}`}
                data-testid={`attendance-row-${participant.id}`}>
                <span
                    className={`${styles.rowName} ${!participant?.hidden && hasParticipantAccess ? styles.rowNameLink : ''}`}
                    onClick={hasParticipantAccess ? onNav : null}>
                    {`${participant?.firstName ?? participant?.hidden} ${participant?.lastName ?? ''}`}
                </span>
                <span className={styles.rowButton}>
                    {attendanceStatus !== 'Not known' && hasGroup1Role ? (
                        <Button
                            id="updateAppointmentButton"
                            type="button"
                            testId={`update_appointment_button_${participant?.id}`}
                            disabled={isUpdateDisabled || !canConductAppointment}
                            content="Update Appointment"
                            onClick={() => onUpdateAppointment(showWarning, participant)}
                        />
                    ) : (
                        <Button
                            id="startAppointmentButton"
                            type="button"
                            testId={`start_appointment_button_${participant?.id}`}
                            disabled={
                                isDisabled ||
                                !canConductAppointment ||
                                (participant?.status === 'Closed' && !hasEditOnClosedRole)
                            }
                            content="Start Appointment"
                            onClick={() => onStartAppointment(showWarning, participant)}
                        />
                    )}
                </span>
                <div className={styles.rowStatusWrapper}>
                    <div className={styles.rowStatus}>{attendanceStatus}</div>
                    {isAuditable && !participant?.hidden && (
                        <div className={styles.auditIcon}>
                            <RestoreIcon onClick={onSearchAuditItems} />
                        </div>
                    )}
                </div>
            </div>
            {showWarning && <div>{InitialAppointmentPONumberNotice()}</div>}
        </>
    );
};

AttendanceRow.propTypes = {
    isDisabled: PropTypes.bool,
    isUpdateDisabled: PropTypes.bool,
    hasParticipantAccess: PropTypes.bool,
    hasGroup1Role: PropTypes.bool,
    hasEditOnClosedRole: PropTypes.bool,
    canConductAppointment: PropTypes.bool,
    isAuditable: PropTypes.bool,
    onSearchAuditItems: PropTypes.func,
    attendanceStatus: PropTypes.string,
    appointmentType: PropTypes.string,
    isPONumberRequired: PropTypes.bool,
    participant: PropTypes.object,
    participantAppointmentId: PropTypes.string,
    onNav: PropTypes.func,
    onStartAppointment: PropTypes.func,
    onUpdateAppointment: PropTypes.func
};

export default AttendanceRow;
